// extracted by mini-css-extract-plugin
export default {"icon":"Icon_icon__O0EnB","iconBg":"Icon_iconBg__fm35b"};